module.exports = __webpack_public_path__ + "img/bda96b9b2e3b31bf25829f4f90c2d0e4.png";